import React from "react";
import { isMobile } from "react-device-detect";
import { Divider, Link, Stack, Typography } from "@mui/material";
import { MixPanelTrackedLink } from "./MixPaneTrackedLink";

export function ListingResultText({ resultCount, filtersCount, resetHandler }) {
    return <Stack sx={styles.mainStack} direction="row" justifyContent="space-between" alignItems="center">
        <Typography sx={styles.fontSize} component="div" color="text.secondary">
            RESULTS FOUND <Typography component="span" variant="bold">{resultCount}</Typography>
        </Typography>

        <Stack color="text.secondary" flexDirection="row" alignItems="center">
            <Typography variant="bold" sx={styles.fontSize} >({filtersCount})&nbsp;</Typography>
            <Typography sx={styles.fontSize}>FILTER(s) SELECTED</Typography>
            <Divider orientation="vertical" sx={{ ml: 1, mr: 1 }} />
            <MixPanelTrackedLink linkButtonProps={{ sx: { justifyContent: 'left', marginRight: '-20px', ...styles.fontSize }}}  type="link" label="Reset" context="Reset filters" href="#" onClick={resetHandler} underline="none"> RESET</MixPanelTrackedLink>
        </Stack>
    </Stack>
}

const styles = {
    mainStack: {
        m: '10px 0'
    },
    fontSize: {
        fontSize: isMobile ? '11px' : '14px'
    }
}